import _ from 'lodash';

import { UPDATE_USER_INFO_SUCCESS, SET_CURRENT_SERVER_TIME } from '@/constants';
import * as constants from './Question.constants';
import * as services from './Question.service';

const addQaAttr = (objQa) => ({
  ...objQa,
  i_feedbackIsOpen: false,
  i_feedbackIsToolong: false,
  i_commentIsOpen: false,
  i_commentIsToolong: false,
  i_commentCountDown: '',
});

const state = {
  isRequest: false,

  qaQuestion: {
    teacherAnswers: [],
    answers: [],
  },

  res_follow: {},

  res_feedback: {},

  res_thumb: {},

  res_comment: {},

  questionReferralList: [],

  questionSharedNote: [],
};

const mutations = {
  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.GET_QA_QUESTION_SUCCESS](state, qaQuestion) {
    if (undefined !== qaQuestion && null !== qaQuestion) {
      state.qaQuestion = addQaAttr({
        ...qaQuestion,
        teacherAnswers: _.map(qaQuestion.teacherAnswers, (answer) => addQaAttr(answer)),
        answers: _.map(qaQuestion.answers, (answer) => addQaAttr(answer)),
      });
    }
  },

  [constants.UPDATE_COMMENT_COUNTDOWN](state, payload) {
    const { currentServerTime, studentId } = payload;
    const updateCommentCountdown = (objQa) => {
      let i_commentCountDown = '';
      _.forEachRight(objQa.comments, (comment) => {
        if (comment.userId === studentId) {
          let timer = 3 * 60 * 1000 - (currentServerTime - comment.commentTime);
          if (timer > 0) {
            timer = timer / 1000;
            let minutes = parseInt(timer / 60, 10);
            let seconds = parseInt(timer % 60, 10);
            minutes = minutes < 10 ? '0' + minutes : minutes;
            seconds = seconds < 10 ? '0' + seconds : seconds;
            i_commentCountDown = minutes + ':' + seconds;
          }
          return false;
        }
      });
      return {
        ...objQa,
        i_commentCountDown,
      };
    };
    state.qaQuestion = updateCommentCountdown({
      ...state.qaQuestion,
      teacherAnswers: _.map(state.qaQuestion.teacherAnswers, (answer) =>
        updateCommentCountdown(answer)
      ),
      answers: _.map(state.qaQuestion.answers, (answer) => updateCommentCountdown(answer)),
    });
  },

  [constants.UPDATE_QA_QUESTION](state, payload) {
    state.qaQuestion = {
      ...state.qaQuestion,
      ...payload,
    };
  },

  [constants.UPDATE_QA_ANSWER](state, payload) {
    const answerIdx = _.findIndex(
      state.qaQuestion.answers,
      (answer) => answer.qaAnswerId === payload.qaAnswerId
    );
    state.qaQuestion.answers.splice(answerIdx, 1, payload);
  },

  [constants.PUSH_QA_TEACHER_ANSWER](state, answer) {
    state.qaQuestion = {
      ...state.qaQuestion,
      teacherAnswers: [...state.qaQuestion.teacherAnswers, addQaAttr(answer)],
    };
  },

  [constants.PUSH_QA_ANSWER](state, answer) {
    state.qaQuestion = {
      ...state.qaQuestion,
      answers: [...state.qaQuestion.answers, addQaAttr(answer)],
    };
  },

  [constants.FOLLOW_QA_QUESTION_SUCCESS](state, res_follow) {
    if (undefined !== res_follow && null !== res_follow) {
      state.res_follow = res_follow;
    }
  },

  [constants.FEEDBACK_QA_QUESTION_SUCCESS](state, res_feedback) {
    if (undefined !== res_feedback && null !== res_feedback) {
      state.res_feedback = res_feedback;
    }
  },

  [constants.THUMB_QA_QUESTION_SUCCESS](state, res_thumb) {
    if (undefined !== res_thumb && null !== res_thumb) {
      state.res_thumb = res_thumb;
    }
  },

  [constants.COMMENT_QA_QUESTION_SUCCESS](state, res_comment) {
    if (undefined !== res_comment && null !== res_comment) {
      state.res_comment = res_comment;
    }
  },

  [constants.GET_QUESTION_REFERRAL_LIST_IN_QUESTION_SUCCESS](state, questionReferralList) {
    if (undefined !== questionReferralList && null !== questionReferralList) {
      state.questionReferralList = questionReferralList;
    }
  },

  [constants.GET_QUESTION_SHARED_NOTE_IN_QUESTION_SUCCESS](state, questionSharedNote) {
    if (questionSharedNote) {
      state.questionSharedNote = questionSharedNote;
    }
  },

  [constants.DUMMY_MUTATION]() {
    //
  },
};

const actions = {
  async getQaQuestion({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getQaQuestion(payload);
    if (200 === res.data.status) {
      const qaQuestion = res.data.data;
      commit(constants.GET_QA_QUESTION_SUCCESS, qaQuestion);
      commit(
        UPDATE_USER_INFO_SUCCESS,
        {
          totalAandC: qaQuestion.totalAandC,
        },
        { root: true }
      );
      commit(SET_CURRENT_SERVER_TIME, qaQuestion.currentServerTime, { root: true });
      commit(constants.SET_IS_REQUEST_STATUS, false);
    }
  },

  updateCommentCountdown({ commit, rootState, rootGetters }) {
    commit(constants.UPDATE_COMMENT_COUNTDOWN, {
      currentServerTime: rootState.currentServerTime,
      studentId: rootGetters.userInfo.studentId,
    });
  },

  async setQuestionUnread({ commit, rootState }, payload) {
    await services.setQuestionUnread(payload);
    commit(
      UPDATE_USER_INFO_SUCCESS,
      {
        totalAandC: rootState.userInfo.totalAandC + 1,
      },
      { root: true }
    );
  },

  async toFollow({ commit, state }, payload) {
    const res = await services.toFollow(payload);
    if (200 === res.data.status) {
      commit(constants.FOLLOW_QA_QUESTION_SUCCESS, res.data);
      commit(constants.UPDATE_QA_QUESTION, {
        isFollowed: true,
        numOfFollow: state.qaQuestion.numOfFollow + 1,
      });
    }
  },

  async toUnFollow({ commit }, payload) {
    const res = await services.toUnFollow(payload);
    if (200 === res.data.status) {
      commit(constants.FOLLOW_QA_QUESTION_SUCCESS, res.data);
      commit(constants.UPDATE_QA_QUESTION, {
        isFollowed: false,
        numOfFollow: state.qaQuestion.numOfFollow - 1,
      });
    }
  },

  async doAccept({ commit }, payload) {
    await services.doAccept(payload);
    commit(constants.DUMMY_MUTATION);
  },

  async postQaGrade({ commit }, payload) {
    await services.postQaGrade(payload);
    commit(constants.DUMMY_MUTATION);
  },

  async feedback({ commit }, payload) {
    const res = await services.feedback(payload);
    commit(constants.FEEDBACK_QA_QUESTION_SUCCESS, res.data);
  },

  async doThumb({ commit }, payload) {
    const res = await services.doThumb(payload);
    commit(constants.THUMB_QA_QUESTION_SUCCESS, res.data);
  },

  async submitComment({ commit }, payload) {
    const res = await services.submitComment(payload);
    commit(constants.COMMENT_QA_QUESTION_SUCCESS, res.data);
  },

  async getQuestionReferralInQuestion({ commit }, payload) {
    const res = await services.getQuestionReferralInQuestion(payload);
    commit(constants.GET_QUESTION_REFERRAL_LIST_IN_QUESTION_SUCCESS, res.data.data);
  },

  async getQuestionSharedNoteInQuestion({ commit }, payload) {
    const res = await services.getQuestionSharedNoteInQuestion(payload);
    commit(constants.GET_QUESTION_SHARED_NOTE_IN_QUESTION_SUCCESS, res.data.data);
  },
};

const getters = {
  qaQuestion: (state) => state.qaQuestion,
  questionSharedNote: (state) => state.questionSharedNote,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
